import { render, staticRenderFns } from "./MobileLanding.vue?vue&type=template&id=4fac90d6&scoped=true"
import script from "./MobileLanding.vue?vue&type=script&lang=js"
export * from "./MobileLanding.vue?vue&type=script&lang=js"
import style0 from "./MobileLanding.vue?vue&type=style&index=0&id=4fac90d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fac90d6",
  null
  
)

export default component.exports